export default __webpack_public_path__ + "static/crm-features-list-2--4cbf5ec2da62b089fe06801963eb28be.png";